import {IActionModel} from "../../shared/models/action.model";
import {
    BOOK_APPOINTMENT_FLOW_NAVIGATION,
    SET_CURRENT_NAV_PARAMS,
    SET_SIDE_MENU_VIEW
} from "../actions/navigation.action";

export interface INavigationReducerState {
    sideMenuView: "compact" | "default";
    currentBookingAppointmentFlowNavigation: "category_selection_screen" | "category_service_selection_screen" | "injury_type_selection_screen" | "time_rate_slot_selection_screen" | "client_type_selection" | "client_form_based_client_type_selection_screen" | "otp_verification_screen" | "booking_appointment_for_screen" | "someone_else_form_screen" | "select_provider_screen" | "select_date_and_time_screen" | "secure_checkout_screen"|"followup-appointment-booking-screen"|"followup-appointment-payment-screen",
    onNavigateBack?: () => void;
    currentNavParams: {
        title: string,
        meta: any
    };
    prevNavParams?: {
        title: string,
        meta: any
    };
}

const INITIAL_STATE: INavigationReducerState = {
    sideMenuView: "default",
    currentBookingAppointmentFlowNavigation: 'category_selection_screen',
    currentNavParams: {
        title: "",
        meta: undefined
    }
};

const navigationReducer = (state: INavigationReducerState = INITIAL_STATE, action: IActionModel): INavigationReducerState => {
    switch (action.type) {
        case SET_CURRENT_NAV_PARAMS:
            return {
                ...state,
                onNavigateBack: action.payload.onNavigateBack,
                prevNavParams: {
                    title: state.currentNavParams.title,
                    meta: state.currentNavParams.meta,
                },
                currentNavParams: {
                    title: action.payload.title,
                    meta: action.payload.meta,
                }
            };
        case SET_SIDE_MENU_VIEW:
            return {
                ...state,
                sideMenuView: action.payload.sideMenuView
            };
        case BOOK_APPOINTMENT_FLOW_NAVIGATION:
            return {
                ...state,
                currentBookingAppointmentFlowNavigation: action.payload,
            };
        default:
            return state;
    }
};

export default navigationReducer;

